import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../../Services/authentification/services/authentication.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ContactInformations } from "../../Models/Contact-informations";
import { ContactInformationsService } from "../../Services/contact-informations.service";
import { PopUpConfirmationComponent } from "../pop-up-confirmation/pop-up-confirmation.component";
import { GoogleTagManagerService } from "../../Services/google-tag-manager.service";
import { LoginComponent } from "admin-common";
import { TranslateService } from "@ngx-translate/core";

export interface loginReturn {
  login: boolean;
  returnUrl?: string;
}

declare const FB: any;

@Component({
    selector: "app-login-dialog",
    templateUrl: "./login-dialog.component.html",
    styleUrls: ["./login-dialog.component.scss"],
    standalone: false
})
export class LoginDialogComponent implements OnInit {
  @Input() loginFromCart: boolean = false;

  @Output() close: EventEmitter<void> = new EventEmitter();
  //  @Output() login: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(LoginComponent) loginModal!: LoginComponent;

  @Output() login: EventEmitter<loginReturn> = new EventEmitter();
  @Output() register: EventEmitter<boolean> = new EventEmitter();
  @Output() paswrd: EventEmitter<boolean> = new EventEmitter();
  theme: any = "ABC";

  loginForm: FormGroup;
  hidePassword = true;
  error = false;
  success = false;
  headerMessage = "Connectez-vous à votre espace privé";
  showPassword = false;
  signingIn = false;
  emailIsBlocked: boolean = false;
  contactInformation?: ContactInformations;

  showLoginModal: boolean = true;

  @Input() isSubscribed: boolean | null | undefined = false;

  loadingConnect = false;
  returnUrl?: string;

  emailError: { status?: number; message?: string } | null = null;
  pwdError: { status?: number; message?: string } | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private contactInformationsService: ContactInformationsService,
    public googleTagManagerService: GoogleTagManagerService,
    private translate: TranslateService,
  ) {
    this.loginForm = this.fb.group({});
  }

  /** Returns the page the user originally wanted, or "/" as a fallback */
  private getSafeReturnUrl(): string {
    const url =
      this.returnUrl || this.route.snapshot.queryParamMap.get("returnUrl");

    // only allow internal paths (prevents open redirect attacks)
    return url && url.startsWith("/") && !url.startsWith("//") ? url : "/";
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ["", Validators.compose([Validators.required, Validators.email])],
      password: ["", Validators.required],
    });
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";

    this.contactInformationsService
      .getContactInformations()
      .subscribe((res) => {
        this.contactInformation = res;
      });
  }

  // Close the login dialog
  closeDialog() {
    // Emit the close event and login event with false
    this.close.emit();
    // this.login.emit(thisloginReturn);
  }

  onLogin(loginData?: { email: string; password: string }) {
    this.loadingConnect = true;
    this.signingIn = true;
    const payload = loginData || this.loginForm.value;

    this.authenticationService
      .login(payload.email.toLowerCase(), payload.password)
      .subscribe(
        (res) => {
          if (res) {
            this.showLoginModal = false;
            this.loadingConnect = false;

            //back to cart
            if (this.loginFromCart) {
              this.router.navigateByUrl("/cart?step=1");
            } else {
              if (this.login.observers.length === 1) {
                this.login.emit({ login: true, returnUrl: this.returnUrl });
                this.router.navigateByUrl(this.getSafeReturnUrl());
                this.signingIn = false;
              } else {
                //TODO:temporarily
                this.router.navigate(["/"]);
              }
            }
          }
        },
        (err) => {
          let message = "";

          try {
            const parsedError = JSON.parse(err.error);

            if ((parsedError.status = 401)) {
              message = this.translate.instant("globalUi.login.badCredentials");
              this.pwdError = {
                status: parsedError.status,
                message: message,
              };
              this.emailError = {
                status: parsedError.status,
                message: message,
              };
            } else if (err.status === 404) {
              message = this.translate.instant("globalUi.login.noAccount");
              this.emailError = {
                status: parsedError.status,
                message: message,
              };
            } else if (err.status === 403) {
              message = this.translate.instant("globalUi.login.notActivated");
            } else {
              message = this.translate.instant("globalUi.login.unexpected");
            }
          } catch {
            message = this.translate.instant("globalUi.login.unexpected");
          }
          this.loadingConnect = false;
        },
      );
  }

  goToPwdReset() {
    this.paswrd.emit(true);
  }

  //use another email
  goBackToAccountChange(formDirective: any) {
    this.emailIsBlocked = false;
    this.loadingConnect = false;
    this.headerMessage = "Connectez-vous à votre espace privé";
    this.error = false;

    //FormGroup /validators reset
    formDirective.resetForm();
    this.loginForm.reset();
  }

  onSignUp() {
    this.register.emit(true);
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  onGmailLogin() {
    //add event to GTM
    let loginEvent = {
      event: "Login",
      method: "ByGmail",
    };
    this.googleTagManagerService.pushEvent(loginEvent);

    const currentUrl = window.location.href;
    const path = this.router.url;

    if (path === "/session/register") {
      // redirect to return url
      this.authenticationService.loginOauth2(
        currentUrl.split("/session/register")[0] + this.returnUrl,
      );
    } else {
      this.authenticationService.loginOauth2(currentUrl);
    }
  }

  onFacebookLogin() {
    FB.login((res: any) => {
      if (res.authResponse?.accessToken) {
        this.loadingConnect = true;
        this.signingIn = true;
        this.authenticationService
          .loginFacebook(res.authResponse.accessToken, res.authResponse.userID)
          .subscribe(
            (res) => {
              this.loadingConnect = false;
              //back to cart
              if (this.loginFromCart) {
                this.router.navigateByUrl("/cart?step=1");
              } else {
                if (this.login.observers.length === 1) {
                  this.login.emit({ login: true, returnUrl: this.returnUrl });
                  this.signingIn = false;
                }
              }
            },
            (err) => {
              switch (err.status) {
                case 500:
                  this.headerMessage = this.translate.instant("globalUi.login.accountNotFound");
                  break;
                default:
                  this.headerMessage = this.translate.instant("globalUi.login.retry");
                  break;
              }
              this.error = true;
              this.signingIn = false;
              this.loadingConnect = false;
            },
          );
      }
    });
  }

  // async delay(ms: number) {
  //   await new Promise(resolve => setTimeout(() => resolve(), ms)).then();
  // }

  openDialoge(userMail: any) {
    /* const dialogRef = this.dialog.open(PopUpConfirmationComponent, {
      width: "380px",
      data: { email: userMail.toLowerCase() },
    });
    dialogRef.afterClosed().subscribe((result) => {});*/
  }

  sentMail() {
    window.location.href = "mailto:" + this.contactInformation?.wissalInfoEmail;
  }
}
